export default __webpack_public_path__ + "static/media/screen1.fcaa5edb.jpg";